import React from "react"
import { Link as RouterLink } from "react-router-dom"
import { useRecoilValue, useRecoilState } from "recoil"
import clsx from "clsx"
import AppBar from "@material-ui/core/AppBar"
import Divider from "@material-ui/core/Divider"
import IconButton from "@material-ui/core/IconButton"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import MenuIcon from "@material-ui/icons/Menu"
import ArrowBackIcon from "@material-ui/icons/ArrowBack"
// import HelpOutlineIcon from "@material-ui/icons/HelpOutline"

import currentAssociation from "../store/currentAssociation"
import currentUser from "../store/currentUser"
import { navMain } from "../store/navMain"

import Avatar from "./Avatar"
import Button from "./Button"
import Logo from "./Logo"

const drawerWidth = 220
const useStyles = makeStyles((theme) => {
  return {
    root: {
      background: theme.palette.background.paper,
      color: theme.palette.primary.dark,
      width: `calc(100% - ${theme.spacing(7) + 1}px)`,
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    shift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    fullWidth: {
      width: "100% !important",
    },
    menuButton: {
      left: 9,
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    },
    hide: {
      display: "none",
    },
    toolbar: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      padding: 0,
      position: "relative",
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    headerContent: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      margin: "0 auto",
      maxWidth: 1280,
      paddingLeft: 40,
      paddingRight: 40,
      width: "100%",
    },
    profile: {
      flexDirection: "row",
      display: "flex",
      alignItems: "center",
    },
  }
})

export default function SiteHeader({ logo, fullWidth, title, global }) {
  const classes = useStyles()
  const theme = useTheme()
  const [open, setOpen] = useRecoilState(navMain)
  const association = useRecoilValue(currentAssociation)
  const user = useRecoilValue(currentUser)
  const handleDrawerOpen = () => {
    setOpen(true)
  }

  return (
    <AppBar
      background={theme.palette.background.paper}
      className={clsx(classes.root, {
        [classes.shift]: open,
        [classes.fullWidth]: fullWidth,
      })}
      elevation={0}
      position="fixed"
    >
      <Toolbar className={classes.toolbar}>
        {" "}
        {logo ? <Logo open bar /> : ""}
        {user.isLoggedIn ? (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
        ) : (
          ""
        )}
        <div className={classes.headerContent}>
          <Typography variant="h1" noWrap>
            {user.isLoggedIn ? (
              !global ? (
                <>
                  <strong>{association.name}</strong> {title ? "/ " : ""}
                </>
              ) : (
                association && (
                  <Button
                    variant="text"
                    startIcon={<ArrowBackIcon />}
                    component={RouterLink}
                    to="/0"
                  >
                    Back
                  </Button>
                )
              )
            ) : (
              ""
            )}
            {title ? title : ""}
          </Typography>
          <div className={classes.profile}>
            {user.isLoggedIn ? (
              "" // <Button variant="text" color="primary" onClick={handleLogout}>Logout</Button>
            ) : (
              <>
                <Button variant="text" color="primary" component={RouterLink} to="/signup">
                  Sign Up
                </Button>
                <Button variant="text" color="primary" component={RouterLink} to="/signin">
                  Sign In
                </Button>
              </>
            )}
            {/* <IconButton>
              <HelpOutlineIcon />
            </IconButton> */}
            <Avatar />
          </div>
        </div>
      </Toolbar>
      <Divider />
    </AppBar>
  )
}
